import * as React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="223920" id="cart-content" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-10 text-center">
          <h1 className="font-default text-5xl md:text-7xl font-bold text-foreground tracking-tighter mb-4">
            Your Selection
          </h1>
          <p className="font-sans text-muted-foreground text-xl max-w-2xl mx-auto leading-relaxed">
            Review your artisan breads and golden pastries before we prepare your order for fresh delivery.
          </p>
        </div>

        <div className="bg-secondary/30 rounded-2xl shadow-sm border border-border p-6 md:p-10 backdrop-blur-sm">
          {}
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}